import clsx from 'clsx';
import React from 'react';
import { SvgIcon } from '../../../base-components/SvgIcon';
import styles from './IconUp.module.scss';

export const IconUp = ({ flip = false }) => {
    return (
        <SvgIcon width={14} height={8}>
            <path
                d="M13 7 7 1 1 7"
                stroke="#2D9CDB"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={clsx(flip && styles.flip)}
            />
        </SvgIcon>
    );
};
